export enum TokenStatus {
  Validating = 0,
  Valid = 1,
  Invalid = 2,
}
